<template>
  <div v-if="paints.length" class="configurator box-outline mb-2">
    <div class="box-title">
      <strong>Válasszon színt:</strong>
      <span v-if="selectedPaint" class="text-white small ml-2">{{ selectedPaint.label }}</span>
    </div>
    <div class="box-content">
      <div class="paints-swatch-row">
        <button
          v-for="paint in paints"
          :key="paint.paintId"
          type="button"
          class="swatch-btn"
          :class="{ 'swatch-btn--selected': selected === paint.paintId }"
          :style="swatchStyle(paint)"
          :title="paint.label"
          :aria-label="paint.label"
          @click="select(paint)"
        ></button>
      </div>
      <p class="paints-disclaimer text-muted small mt-2 mb-0">
        Nem minden szín érhető el. Egyes színek felárral járhatnak. Kérjük, érdeklődjön.
      </p>
    </div>
  </div>
</template>

<script>
  import Vue from 'vue';
  import { Component, Prop } from 'vue-property-decorator';
  import { namespace } from 'vuex-class';

  const configuratorModule = namespace('configurator');

  @Component
  export default class ConfiguratorPaints extends Vue {
    @Prop(String) typeId;
    @Prop({ type: String, default: '' }) defaultPaintId;

    @configuratorModule.Action('setPaint') setPaint;

    paints = [];
    selected = null;
    loading = false;

    get selectedPaint() {
      if (!this.selected) return null;
      return this.paints.find(p => p.paintId === this.selected) || null;
    }

    created() {
      if (this.defaultPaintId) {
        this.selected = this.defaultPaintId;
        this.setPaint(this.defaultPaintId);
      }
    }

    mounted() {
      if (this.typeId) {
        this.loading = true;
        axios.get(`/api/imagin-paints/${this.typeId}`)
          .then(response => {
            this.paints = Array.isArray(response.data) ? response.data : [];
          })
          .catch(err => {
            console.warn('ConfiguratorPaints: fetch failed', err);
          })
          .finally(() => {
            this.loading = false;
          });
      }
    }

    select(paint) {
      this.selected = paint.paintId;
      this.setPaint(paint.paintId);
    }

    swatchStyle(paint) {
      const high = paint.hexHigh || paint.hex;
      const mid  = paint.hex;
      const low  = paint.hexLow || paint.hex;
      return {
        background: `radial-gradient(circle at 35% 30%, ${high} 0%, ${mid} 45%, ${low} 100%)`,
      };
    }
  }
</script>

<style scoped>
  .paints-swatch-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    padding: 4px 0;
  }

  .swatch-btn {
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 1px solid rgba(0, 0, 0, 0.08);
    cursor: pointer;
    padding: 0;
    flex-shrink: 0;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.28);
    transition: box-shadow 0.15s, transform 0.12s;
    outline: none;
  }

  .swatch-btn::after {
    content: '';
    position: absolute;
    top: 14%;
    left: 20%;
    width: 42%;
    height: 32%;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(255, 255, 255, 0.65) 0%, rgba(255, 255, 255, 0) 70%);
    pointer-events: none;
  }

  .swatch-btn:hover {
    transform: scale(1.08);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.32);
  }

  .swatch-btn--selected {
    box-shadow: 0 0 0 2px #fff, 0 0 0 4px #29b6e6, 0 3px 6px rgba(0, 0, 0, 0.28);
    transform: scale(1.05);
  }

  .paints-disclaimer {
    font-size: 0.75rem;
    line-height: 1.4;
  }

  /* Phone only: shrink swatches so ~10 fit per row (desktop keeps 40px) */
  @media (max-width: 767.98px) {
    .paints-swatch-row {
      gap: 6px;
    }
    .swatch-btn {
      width: 30px;
      height: 30px;
    }
  }
</style>
